import Card from "./Card";

function InfoCard({

    title,

    value,

    sub,

    valueStyle

}){

    return(

        <Card>

            <div className="info-title">

                {title}

            </div>

            <div className="info-value" style={valueStyle}>

                {value}

            </div>

            {

                sub &&

                <div className="info-sub">

                    {sub}

                </div>

            }

        </Card>

    );

}

export default InfoCard;